import React from 'react';
import TableSkeletonLoader from './TableSkeletonLoader';

export default {
  title: 'Components/LoadingSkeletons/TableSkeletonLoader',
  component: TableSkeletonLoader,
  parameters: {
    layout: 'left',
  },
  tags: ['autodocs'],
  argTypes: {
    shouldEnableAnimation: {
      control: { type: 'boolean' },
      description: 'Controls the shouldEnableAnimation prop. By default, it is set to false to keep animations disabled. Set this value to true to enable animations.',
      table: {
        type: { summary: 'Boolean' },
        defaultValue: { summary: false },
      },
    },
    UsageHint: {
      description: 'Usage example: `<TableSkeletonLoader numRows={5} numColumns={5} />`',
    },
    numRows: {
      control: { type: 'number' },
      description: 'Defines the number of rows to render in the table skeleton.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 10 },
      },
    },
    numColumns: {
      control: { type: 'number' },
      description: 'Defines the number of columns to render in the table skeleton.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 10 },
      },
    },
    skeletonHeight: {
      control: { type: 'number' },
      description: 'Specifies the height of each skeleton cell in the table.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: 20 },
      },
    },
    skeletonTHeadWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeletons in the table header.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '80%' },
      },
    },
    skeletonWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeletons in the table body cells.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '100%' },
      },
    },
    skeletonBorderRadius: {
      control: { type: 'text' },
      description: 'Defines the border radius of each skeleton cell, providing a rounded appearance.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '4px' },
      },
    },
  },
};

// Default Template
const Template = (args) => <TableSkeletonLoader {...args} />;

export const Default = Template.bind({});
Default.args = {
  numRows: 10,
  numColumns: 10,
  skeletonHeight: 20,
  skeletonTHeadWidth: '80%',
  skeletonWidth: '100%',
  skeletonBorderRadius: '4px',
};

export const SmallTableSkeleton = Template.bind({});
SmallTableSkeleton.args = {
  numRows: 5,
  numColumns: 5,
  skeletonHeight: 16,
  skeletonTHeadWidth: '70%',
  skeletonWidth: '90%',
  skeletonBorderRadius: '4px',
};

export const LargeTableSkeleton = Template.bind({});
LargeTableSkeleton.args = {
  numRows: 15,
  numColumns: 15,
  skeletonHeight: 22,
  skeletonTHeadWidth: '90%',
  skeletonWidth: '100%',
  skeletonBorderRadius: '6px',
};
